<template>
  <b-container id="main-container" fluid style>
    <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
      <b-col class cols="12">
        <nav-header></nav-header>
      </b-col>
    </b-row>
    <b-row style="width: 100%; margin-top: 60px" align-h="center">
      <b-col class="row-section" cols="12">
        <b-row
          class="main-jumbotron left-margin-flex no-padding-top-mid"
          style="padding-bottom: 80px"
        >
          <b-col xl="6" class="pl-0 pr-0 pt-5 no-padding-top-mid">
            <h1
              data-aos="fade-right"
              data-aos-delay="250"
              class="center-align-mid"
            >
              Create your account today and take advantage of Truthbrush&trade;
              for your practice
            </h1>
            <b-row
              class="ml-0 mt-5 center-align-mid"
              data-aos="fade-right"
              data-aos-delay="400"
            >
              <b-col class="pl-0 pr-0 center-align-mid">
                <b-button
                  pill
                  variant="primary"
                  href="https://app.truthbrush.com/#/signup"
                  size="lg"
                  class="hub-blue btn-truthbrush bluebtn2"
                  style='color:white!important; background-color: #12b8ed '
                  >Create an account</b-button
                >
                <b-button
                  pill
                  variant="outline-primary"
                  href="https://app.truthbrush.com/#/login?id=rob%40candibell.com&credential=418227"
                  size="lg"
                  class="bluebtn2"
                  style="margin-left: 20px"
                  >See a live demo</b-button
                >
              </b-col>
              
            </b-row>
            <b-row class="mt-5 center-align-mid">
              <b-col class="pl-0 pr-0">
                <h5 style="padding-right: 100px; line-height:1.5" class='h-padding-md'>
                  Contact us at <a
                    href="mailto:sale@candibell.com"
                    id="show-btn"
                    style="font-size: 1.25rem; color: #2ebfde !important"
                    v-b-modal.modal-1
                    >sale@candibell.com</a> for dental practice pricing.
                  <a
                    href="#"
                    hidden
                    id="show-btn"
                    style="font-size: 1.25rem; color: #2ebfde !important"
                    v-b-modal.modal-1
                    >Learn More &#8594;</a
                  >
                </h5>
                <b-modal
                  id="modal-1"
                  size="md"
                  title="Truthbrush Provider Program"
                  centered
                  hide-footer
                >
                  <b-container fluid style class="pl-0 pr-0">
                    <b-row class="pt-2">
                      <h4>
                        Get started with Truthbrush for your practice:
                      </h4>
                    </b-row>

                    <b-row class="pt-2 pl-0 pr-2" >
                      <ul>
                        <li>
                          <h5 style='line-height:1.5'>
                            We are committed to delivering a quality product
                            that will enable you to offer better daily care.
                          </h5>
                        </li>
                        <li>
                          <h5 style='line-height:1.5'>
                            We have tiered pricing for dental practices. Please
                            contact us to learn more.
                          </h5>
                        </li>

                        <li>
                          <h5 style='line-height:1.5'>
                            Want to evaluate Truthbrush before making a decision? Ask us about the
                            introductory offer.
                          </h5>
                        </li>
                      </ul>
                    </b-row>


                    <b-row class="ml-0 mt-0 pt-2 pb-2">
                      <b-col cols="12" style="text-align: center">
                        <b-button
                          pill
                          variant="primary"
                          href="mailto:sale@candibell.com"
                          size="lg"
                          class="hub-blue btn-truthbrush"
                          >Contact Us</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-container>
                </b-modal>
              </b-col>
            </b-row>
            <b-row class="mt-2 center-align-mid" hidden>
              <b-col class="pl-0 pr-0">
                <h5>
                  Contact us for dental practice pricing:
                  <a
                    href="mailto:sale@candibell.com"
                    id="show-btn"
                    style="font-size: 1.25rem; color: #2ebfde !important"
                    v-b-modal.modal-1
                    >sale@candibell.com &#8594;</a
                  >
                </h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col xl="6" class="pl-0 pr-0 pt-3 more-padding-top-small">
            <b-row align-v="center" style="height: 100%">
              <b-col class="pl-0 pr-0">
                <b-img src="img/group-7.jpg" fluid center></b-img>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>


    

    <b-row style="width: 100%; background-color: #9b6f4c" align-h="center">
      <b-col
        class="row-section remove-min-height main-jumbotron"
        cols="12"
        style="min-height: 786px"
      >
        <b-row
          style="background-color: ; padding-top: 70px; color: white"
          class="ml-0 mr-0 sub-heading2"
          align-h="center"
          >Provide enhanced care with Truthbrush&trade;</b-row
        >

        <b-row style="background-color: ; padding-top: 20px" align-h="center">
          <b-col
          class='text-body'
            style="
              font-size: 20px;
              padding-bottom: 70px;
              text-align: center;
              color: white!important;
              max-width: 800px;
            "
            >Truthbrush&trade; is a connected device that provides real-time,
            actionable, information on the brush habits of your patients. You
            will be alerted to patients that need your assistance and can reach
            out to them in a very natural and unobtrusive way. With Truthbrush
            you can provide new services for coaching and building great home
            care habits</b-col
          >
        </b-row>
      </b-col>
    </b-row>

    <b-row
      style="width: 100%; margin-top: -400px"
      align-h="center"
      class="remove-margin-top"
    >
      <b-col class="row-section" cols="12">
        <b-row>
          <b-col>
            <b-img
              src="img/video.jpg"
              fluid
              center
              style="border-radius: 1rem"
            ></b-img>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row
      style="width: 100%; padding-top: 50px"
      class="main-jumbotron"
      align-h="center"
    >
      <b-col class="row-section" cols="12">
        <b-row class="pl-5 pr-5 no-h-padding-small">
          <b-col md="6">
            <b-row
              align-v="center"
              style="height: 100%"
              data-aos="zoom-in"
              data-aos-delay="50"
              data-aos-offset="200"
            >
              <b-col>
                <h1 class="sub-heading2">Develop your practice</h1>
                <p class="text-body pt-3">
                  Our program allows you to be more proactive with your
                  patients. With Truthbrush&trade; you can offer a new service
                  to help monitor your patients from the moment that they leave
                  the office. There is no replacement for proper brushing and
                  sending them off for six months on their own leaves you in the
                  dark. You can now offer remote monitoring, check in with your
                  families and recommend interim visits to improve brush
                  performance.
                </p>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            md="6"
            class="pt-3"
            data-aos="zoom-in"
            data-aos-delay="50"
            data-aos-offset="200"
          >
            <b-img src="img/group-5.jpg" fluid center></b-img>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row
      style="width: 100%; padding-top: 50px"
      class="main-jumbotron"
      align-h="center"
    >
      <b-col class="row-section" cols="12">
        <b-row class="pl-5 pr-5 no-h-padding-small">
          <b-col
            md="6"
            class="pt-3"
            data-aos="zoom-in"
            data-aos-delay="50"
            data-aos-offset="200"
          >
            <b-img src="img/group-5b.jpg" fluid center></b-img>
          </b-col>
          <b-col
            md="6"
            data-aos="zoom-in"
            data-aos-delay="50"
            data-aos-offset="200"
            class="more-padding-top-small"
          >
            <b-row align-v="center" style="height: 100%">
              <b-col>
                <h1 class="sub-heading2">Truthbrush direct connect</h1>
                <p class="text-body pt-3">
                  Communication with your patient families has never been so
                  easy. The Truthbrush dashboard highlights red-flag areas
                  making it easy to spot problems. A pre-set suggested message
                  can be sent at the click of a button that will appear at the
                  top of the Truthbrush app and can be delivered as a
                  notification. Message text can be adapted to your voice and
                  can appear with your logo.
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row
      style="width: 100%"
      align-h="center"
      class="main-jumbotron no-padding-top-small"
    >
      <b-col class="row-section" cols="12">
        <b-row class="pl-5 pr-5 no-h-padding-small">
          <b-col md="6">
            <b-row
              align-v="center"
              style="height: 100%"
              data-aos="zoom-in"
              data-aos-delay="50"
              data-aos-offset="200"
            >
              <b-col>
                <h1 class="sub-heading2">The perfect giveaway</h1>
                <p class="text-body pt-3">
                  Do you offer your patients a toothbrush, water bottle, tube
                  squeezer or other handout at the end of a visit? Try the
                  Truthbrush, your patients and parents will love it. It is the
                  only goodie in the bag that will help you to provide better
                  care.
                </p>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            md="6"
            class="pt-3"
            data-aos="zoom-in"
            data-aos-delay="50"
            data-aos-offset="200"
          >
            <b-img src="img/group-5c.jpg" fluid center></b-img>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row
      style="width: 100%; padding-top: 50px; padding-bottom: 50px"
      class="main-jumbotron"
      align-h="center"
    >
      <b-col class="row-section" cols="12">
        <b-row class="pl-5 pr-5 no-h-padding-small">
          <b-col
            md="6"
            class="pt-3"
            data-aos="zoom-in"
            data-aos-delay="50"
            data-aos-offset="200"
          >
            <b-img src="img/group-5d.jpg" fluid center></b-img>
          </b-col>
          <b-col
            md="6"
            data-aos="zoom-in"
            data-aos-delay="50"
            data-aos-offset="200"
            class="more-padding-top-small"
          >
            <b-row align-v="center" style="height: 100%">
              <b-col>
                <h1 class="sub-heading2">Easy to get started</h1>
                <p class="text-body pt-3">
                  Truthbrush&trade; trackers are a fun new technology that your
                  patients will love. They come in many designs and can make a
                  great giveaway. The hub and trackers are easy to setup.
                  Families can setup and share the Truthbrush&trade; data
                  securely right from our mobile app in under five minutes. Data
                  including brush frequency, time of day, duration and coverage
                  are immediately available to you in the dentist portal.
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>


<b-row
        style="width: 100%; position: relative; padding-bottom: 60px"
        align-h="center"
        class="main-jumbotron reduced-pb-0"
      >
        <b-col class="pl-0 pr-0 hide-when-small" style="z-index: 999">
          <b-img-lazy
            src="/img/bg2-min.jpg"
            fluid
            center
            style="width: 100%"
          ></b-img-lazy>
        </b-col>

        <b-col class="pl-0 pr-0 hide-when-big" style="z-index: 999">
          <b-img-lazy src="/img/bg2a-min.jpg" fluid></b-img-lazy>
        </b-col>

        <b-col style="z-index: 0; position: absolute; width: 1px; height: 1px">
          <div
            class="wistia_responsive_padding"
            style="padding: 56.25% 0 0 0; position: relative"
          >
            <div
              class="wistia_responsive_wrapper"
              style="
                height: 100%;
                left: 0;
                position: absolute;
                top: 0;
                width: 100%;
              "
            >
              <span
                class="
                  wistia_embed wistia_async_zvkx0dtjv0
                  popover=true
                  popoverAnimateThumbnail=true
                  videoFoam=true
                "
                style="
                  display: inline-block;
                  height: 100%;
                  position: relative;
                  width: 100%;
                "
                >&nbsp;</span
              >
            </div>
          </div>
        </b-col>

        <div
          style="position: absolute; left: 4%; z-index: 999; width: 96%"
          class="video-title-top-position"
          data-aos="fade-up"
          data-aos-delay="250"
        >
          <div style="position: relative; left: -2%; border-width: 9px">
            <b-row
              class="blue-text justify-content-center"
              style="color: #12b8ed; padding-top:120px"
            >
              Extending dental care
            </b-row>

            <b-row class="justify-content-center pt-3">
              <h1 style="max-width: 820px; color: white; text-align: center">
                Your dentist is a key partner in managing the health of your
                family
              </h1>
            </b-row>
            <b-row style="justify-content: center; padding-top: 25px">
              <b-button
                pill
                size="lg"
                style="
                  background-color: #12b8ed;
                  border: none;
                  padding: 10px 20px;
                "
                v-b-modal.extend-dental-care
              >
                Watch the video
              </b-button>
            </b-row>
          </div>
        </div>
      </b-row>

    <b-row
      style="
        width: 100%;
        padding-top: 50px;
        padding-bottom: 40px;
        background-color: #f6f6f6;
      "
      class="main-jumbotron"
      align-h="center"
    >
      <b-col class="row-section" cols="12">
        <b-row
          style="padding-top: 30px; padding-bottom: 40px; color: #3c4553"
          class="ml-0 mr-0 sub-heading2 no-padding-top-small main-jumbotron"
          align-h="center"
          >Simple, easy to use dashboard</b-row
        >
        <b-row data-aos="zoom-in" data-aos-delay="650">
          <b-col class="pl-0 pr-0">
            <b-img src="img/004-v-2.png" fluid center></b-img>
          </b-col>
        </b-row>
        <b-row
          style="padding-top: 80px; padding-left: 7%; padding-right: 7%"
          class="more-padding-top-small no-h-padding-small"
        >
          <b-col md="4" data-aos="fade" data-aos-delay="450">
            <b-row class="pt-3">
              <b-col class="pl-0 pt-0">
                <p
                  style=" font-size: 24px"
                  class="center-align-small"
                >
                  Real-time intelligence
                </p>
              </b-col>
            </b-row>
            <b-row
              style="font-size: 16px; padding-bottom: 20px"
              class="center-align-small"
              >Truthbrush&trade; is a connected device that provides real-time
              intelligence on the brush habits of your patients. You will be
              alerted to patients that need your assistance and help you to
              provide new services for coaching and building great brush
              habits.</b-row
            >
          </b-col>
          <b-col md="4" data-aos="fade" data-aos-delay="650">
            <b-row class="pt-3">
              <b-col class="pl-0 pt-0">
                <p
                  style=" font-size: 24px"
                  class="center-align-small"
                >
                  Performace Score
                </p>
              </b-col>
            </b-row>
            <b-row
              style="font-size: 16px; padding-bottom: 20px"
              class="center-align-small"
              >The dentist portal is a web site that shows the brush frequency,
              duration and completeness for each off your patients. The data is
              distilled into a digestible view that quickly provides the
              information that you need.</b-row
            >
          </b-col>
          <b-col md="4" data-aos="fade" data-aos-delay="750">
            <b-row class="pt-3">
              <b-col class="pl-0 pt-0">
                <p
                  style=" font-size: 24px"
                  class="center-align-small"
                >
                  Activity Log
                </p>
              </b-col>
            </b-row>
            <b-row style="font-size: 16px" class="center-align-small"
              >Compare the performance of your practice to the entire body of
              Truthbrush&trade; users. Understand the demographics that impact
              brush performance.</b-row
            >
          </b-col>
        </b-row>

        <b-row
          style="padding-top: 80px; padding-left: 10%; padding-right: 10%"
          class="more-padding-top-small insight-section modest-padding-top-small"
        >
          <b-col
            md="12"
            data-aos="fade"
            data-aos-delay="450"
            class="sub-heading2"
            style="text-align: center; color: #3c4553"
            >Insights</b-col
          >
          <b-col
            cols="12"
            style="font-size: 20px; color: #3c4553; text-align: center"
            class="pt-3 text-body"
            >Aggregated brush data provides deep insights into the habits and
            performance of your practice compared to the universe of Truthbrush
            users. Identify patterns based on region, age, gender, rewards
            incentives, brush time of day and other metrics. As you collect data
            it can be analyzed by our AI – assisted machine learning algorithm
            for early disease detection and prevention.</b-col
          >
          <b-col class="pt-5">
            <b-img src="img/group-22@2x.png" fluid center></b-img>
          </b-col>
        </b-row>

        <b-row align-h="center">
          <b-col
            cols="12"
            class="hide-when-small pt-5"
            style="max-width: 1150px"
          >
            <hr style="width: 100%; border: 0.5px solid gray" />
          </b-col>
        </b-row>
        <b-row align-h="center" class="pt-5 pl-2 pr-2">
          <b-col
            class="pt-4 pb-4"
            style="
              padding-left: 3%;
              padding-right: 3%;
              border: 3px solid #000000;
              border-radius: 15px;
              max-width: 1150px;
            "
          >
            <b-row>
              <b-col md="6">
                <b-row align-v="center" style="height: 100%">
                  <b-col>
                    <h1 class="sub-heading2">How to get started</h1>
                    <p class="text-body pt-3">
                      Simply create your account at on our dentist dashboard and
                      invite your first patient. There is no fee to get started.
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="6">
                <b-row align-v="center" style="height: 100%" align-h="end">
                  <b-col cols="auto" class="center-align-mid">
                    <b-button
                      pill
                      style="
                        font-size: 24px;
                        background-color: #3c4553;
                        padding-left: 35px;
                        padding-right: 35px;
                      "
                      class="btn-truthbrush reducefont"
                      href="https://app.truthbrush.com/#/login"
                      >Sign up today</b-button
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row
      style="
        width: 100%;
        padding-top: 80px;
        padding-bottom: 50px;
        background-color: #33383a;
      "
      align-h="center"
    >
      <b-col style="max-width: 1200px; margin: 0 auto">
        <b-row>
          <b-col cols="12" class="reduced-h-padding">
            <b-row>
              <b-col
                class="pl-0 pr-0 medium"
                style="color: white; font-size: 24px; text-align: center"
                >Endorsed by leading dentists</b-col
              >
            </b-row>

            <b-row class="pt-5 center-justify-small">
              <b-col
                class="pl-0 pr-0 text-body"
                md="8"
                style="
                  color: white!important;
                  font-size: 24px;
                  letter-spacing: -0.2px;
                  margin: auto;
                "
                >Don’t take our word for it, Truthbrush&trade; is endorsed by
                leading dentists who have seen what it can do for their
                patients.</b-col
              >
            </b-row>
          </b-col>
          <b-col cols="12" class="hide-when-small pt-5">
            <hr style="width: 100%; border: 0.5px solid gray" />
          </b-col>
          <b-col cols="12" class="pl-0 pr-0">
            <b-row class="pt-4 pl-0 pr-0 no-h-padding-small">
              <b-col md="6" class="pt-3 pl-0 pr-0">
                <b-img src="img/img-6578.jpg" fluid left></b-img>
              </b-col>
              <b-col md="6" class="chief-dentist more-padding-top-small">
                <b-row align-v="center" style="height: 100%">
                  <b-col>
                    <h1 class="sub-heading2" style="color: white">
                      Our Chief Dentist
                    </h1>
                    <p class="text-body pt-3" style="color: white !important">
                      Dr. Paul Johnson runs a pediatric dental practice in
                      Wellesley, Massachusetts. Dr. Johnson and his professional
                      team specialize in providing state-of-the-art dental care
                      that is especially suited to the needs of infants,
                      children, and teenagers. They understand that some
                      children are apprehensive about visiting the dentist,
                      which is why they have created a personalized, relaxed,
                      child-friendly environment designed to enhance your
                      child’s dental experience. Their goal is to have children
                      enjoy going to the dentist and retain that same positive
                      attitude into adulthood. Dr. Johnson is a past president
                      of the Mass Academy of Pediatric Dentistry and was named a
                      Top Dentist in Boston Magazine for 2020.
                    </p>
                    <p class="text-body pt-3" style="color: white !important">
                      Have a question about Truthbrush&trade;?
                    </p>
                    <a
                      href="mailto:paul@candibell.com"
                      class="text-body pt-3 center-align-mid"
                      style="color: #2ebfde !important"
                      >Ask Dr. Johnson &#8594;</a
                    >
                    
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row style="width: 100%">
      <nav-footer></nav-footer>
    </b-row>
    <b-row>
        <b-modal id="extend-dental-care" hide-backdrop size="xl" centered title="BootstrapVue">
          <b-embed
            type="iframe"
            aspect="16by9"
            src="https://www.youtube.com/embed/j-p9BniiQHg"
            allowfullscreen
          ></b-embed>
        </b-modal>
      </b-row>
  </b-container>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
export default {
  name: "Provider",
  components: {
    NavHeader,
    NavFooter,
  },

  data() {
    return {};
  },
  mounted() {
    /*
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://fast.wistia.com/assets/external/E-v1.js"
    );

    document.head.appendChild(recaptchaScript);

    this.video_init();
    */
  },
  methods: {
    /*
    video_init() {
      window._wq = window._wq || [];
      var context = this;
      window._wq.push({
        id: "zvkx0dtjv0",
        onReady: function (video) {
          context.video1 = video;
        },
      });

      window._wq.push({
        id: "xf65loyzdr",
        onReady: function (video) {
          context.video2 = video;
        },
      });
    },
    video1_start() {
      this.video1.play();
    },
    video2_start() {
      this.video2.play();
    },
    */
  },
};
</script>

<style lang="scss">
#extend-dental-care{
 header, footer{
  display:none
 }
 .modal-body{
  padding:0
 }
}

.sub-heading2 {
  
  font-size: 48px;
}

.text-body {
  font-size: 20px;
}

@media (max-width: 575px) {
  .chief-dentist,
  .chief-dentist .col {
    padding-left: 0;
    padding-right: 0;
  }
  .chief-dentist a {
    margin: 0 auto;
  }
  .more-padding-top-small {
    padding-top: 25px !important;
  }
  .no-padding-top-small {
    padding-top: 0 !important;
  }

  .insight-section {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .center-align-small {
    text-align: center !important;
  }

  .bluebtn2 {
    margin-top: 20px;
    margin-left:0!important;
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
  .h-padding-small{
    padding-left:10px!important;
    padding-right:10px!important;
  }

  .text-body {
    font-size: 18px!important;
    text-align: center;
  }
}

@media (max-width: 1199px) {
  .h-padding-md{
     padding-left:10px!important;
    padding-right:10px!important;
  }
  .sub-heading2 {
    
    font-size: 32px;
    text-align: center;
  }


  .remove-min-height {
    min-height: 0 !important;
  }
  .remove-margin-top {
    margin-top: 35px !important;
  }

  .no-h-padding-small {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .reduced-h-padding {
    padding-left: 0 !important;
    padding-right: 0 !important;
    .row {
      text-align: center;
    }
  }
  .center-align-mid {
    text-align: center !important;
    margin: auto;
  }
}
</style>

